import styled from "styled-components"
import { breakpoint, color, transition } from "../../../configs/utilities"

export const PageTitle = styled.h1`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "30px")};
  font-weight: 600;
  text-align: ${props => (props.textAlign ? props.textAlign : "left")};;
  max-width: ${props => (props.maxWidthSm ? props.maxWidthSm : "300px")};
  color: ${props => (props.color ? props.color : color.black)};
  
  
  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 7vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 34px;
    max-width: ${props => (props.maxWidthMd ? props.maxWidthMd : "400px")};
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "46px")};
    line-height: 56px;
    max-width: ${props => (props.maxWidthXl ? props.maxWidthXl : "500px")};
    }
  
  span {
    display: block;
    font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "16px")};
    font-weight: 400;
    line-height: 20px;
    color: ${props => (props.colorSpan ? props.colorSpan : color.gray)};
    
      @media screen and (max-width: ${breakpoint.xsm}) {
        font-size: 4vw;
      }
    
      @media screen and (min-width: ${breakpoint.md}) {
        font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "18px")};
        max-width: ${props =>
          props.maxWidthMdSpan ? props.maxWidthMdSpan : "420px"};
      }
    
      @media screen and (min-width: ${breakpoint.xl}) {
        font-size: 20px;
        line-height: 24px;
        max-width: ${props =>
          props.maxWidthXlSpan ? props.maxWidthXlSpan : "520px"};
      }
    }
  }
`

export const PageTitleDescription = styled.span`
  display: block;
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "16px")};
  font-weight: 400;
  line-height: 20px;
  color: ${props => (props.colorSpan ? props.colorSpan : color.gray)};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 4vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "18px")};
    max-width: ${props =>
      props.maxWidthMdSpan ? props.maxWidthMdSpan : "420px"};
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 20px;
    line-height: 24px;
    max-width: ${props =>
      props.maxWidthXlSpan ? props.maxWidthXlSpan : "520px"};
  }
`

export const PageSubTitle = styled.p`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "16px")};
  font-weight: 400;
  line-height: 20px;
  color: ${color.gray};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 4vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "18px")};
    max-width: 420px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 20px;
    line-height: 24px;
    max-width: 520px;
  }
`

export const PageDescription = styled.p`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "16px")};
  font-weight: 300;
  line-height: 20px;
  color: ${props => props.color || color.black};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 4vw;
  }

  @media screen and (min-width: ${breakpoint.xxl}) {
    line-height: 24px;
  }
`

export const SectionTitle = styled.h2`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "24px")};
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 20px;
  color: ${props => props.color || color.black};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 6vw;
    line-height: 6vw;
    font-weight: 700;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 26px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "36px")};
    margin-bottom: 40px;
    line-height: 46px;
    max-width: ${props => (props.maxWidthXl ? props.maxWidthXl : "600px")};
  }
`

export const SectionTitleHighlight = styled.span`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "24px")};
  line-height: 40px;
  font-weight: 700;
  margin-bottom: 20px;
  color: ${props => props.color || color.blue};
  //border-bottom: 2px solid ${color.blue};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 6vw;
    line-height: 6vw;
    font-weight: 800;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 26px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "36px")};
    margin-bottom: 40px;
    line-height: 46px;
    max-width: ${props => (props.maxWidthXl ? props.maxWidthXl : "600px")};
  }
`

export const SectionDescription = styled.p`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "14px")};
  font-weight: 300;
  line-height: 20px;
  text-transform: uppercase;
  color: ${props => props.color || color.blue};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 4vw;
  }

  @media screen and (min-width: ${breakpoint.xxl}) {
    line-height: 24px;
  }
`

export const SectionText = styled.p`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "16px")};
  font-weight: 400;
  margin: 10px 0;
  line-height: 24px;
  color: ${props => props.color || color.gray};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 4vw;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "18px")};
    font-weight: 300;
    line-height: 28px;
  }
`

export const CardTitle = styled.p`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "16px")};
  font-weight: 500;
  color: ${props => props.color || color.black};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 6vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 18px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "18px")};
    max-width: 520px;
  }
`

export const CardText = styled.span`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "13px")};
  font-weight: 400;
  margin: 10px 0;
  color: ${props => props.color || color.gray};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 3vw;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "16px")};
  }
`

export const SmallText = styled.span`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "12px")};
  font-weight: 400;
  margin: 10px 0;
  color: ${props => props.color || color.gray};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 3vw;
  }
`

export const RankingTitle = styled.p`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "26px")};
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: ${props => props.color || color.blue};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 6vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 20px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "32px")};
    margin-bottom: 40px;
  }
`

export const MoverTitle = styled.h1`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "30px")};
  font-weight: 600;
  text-align: left;
  max-width: 500px;
  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 7vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 34px;
    max-width: 700px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "40px")};
    line-height: 52px;
    max-width: 700px;
  }
`

export const MoversCardTitle = styled.span`
  font-size: ${props => (props.fontSizeSm ? props.fontSizeSm : "20px")};
  font-weight: 500;
  margin-bottom: 20px;
  color: ${props => props.color || color.black};

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 5vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 23px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: ${props => (props.fontSizeXl ? props.fontSizeXl : "26px")};
    margin-bottom: 40px;
    max-width: ${props => (props.maxWidthXl ? props.maxWidthXl : "560px")};
  }
`

export const ChartTitle = styled.p`
  font-size: 14px;
  color: ${color.silver};
  font-weight: 400;
  text-align: left;
  margin-bottom: 10px;
`

export const DisclaimerText = styled.p`
  font-size: 12px;
  line-height: 22px;
  color: ${color.silver};
  background: ${color.blueLight};
  padding: 5px 15px;
  border-radius: 4px;
  transition: ${transition.default};
  cursor: pointer;
  opacity: 0.6;

  @media screen and (min-width: ${breakpoint.lg}) {
    padding: 5px 20px;
  }
  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 5px 30px;
  }

  &:hover {
    opacity: 1;
  }
`
